<div class="card entity-management-card" [style.height]="containerHeight" [ngStyle]="componentColourStyles">

  <!-- Loading Overlay -->
  <div *ngIf="loading" class="loading-overlay">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <!-- Header Bar -->
  <div class="entity-card-header" *ngIf="data?.header">
    <div class="header-left">
      <ng-container *ngFor="let dropdown of data.header.dropdowns">
        <div class="header-dropdown">
          <label>{{ dropdown.label }}</label>
          <div class="custom-dropdown" [style.width]="dropdown.width || dropdown.dropdownWidth">
            <button type="button" class="custom-dropdown-trigger" (click)="toggleHeaderDropdown(dropdown.key, $event)">
              <span>{{ getDropdownSelectedLabel(dropdown, currentFilters[dropdown.key]) }}</span>
              <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <div class="custom-dropdown-panel" *ngIf="isHeaderDropdownOpen(dropdown.key)"
              (click)="$event.stopPropagation()">
              <input class="custom-dropdown-search" type="text" placeholder="Search"
                [value]="getDropdownSearchControl(dropdown.key).value || ''"
                (input)="setDropdownSearchTerm(dropdown.key, $any($event.target).value)">
              <button type="button" class="custom-dropdown-option is-placeholder">
                --Select--
              </button>
              <button type="button" class="custom-dropdown-option"
                *ngFor="let option of getFilteredDropdownOptions(dropdown)"
                [class.selected]="isHeaderDropdownOptionSelected(dropdown, option)"
                (click)="selectHeaderDropdownOption(dropdown, option)">
                <span>{{ getDropdownOptionLabel(dropdown, option) }}</span>
                <mat-icon *ngIf="isHeaderDropdownOptionSelected(dropdown, option)">check</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="header-center">
      <span class="header-title">{{ headerTitle }}</span>
    </div>

    <div class="header-right">
      <ng-container *ngFor="let action of data.header.actions">
        <button class="header-icon" mat-icon-button [disabled]="isHeaderActionDisabled(action)"
          (click)="handleHeaderAction(action.actionId, action)" [attr.aria-label]="action.tooltip || action.actionId"
          [matTooltip]="action.tooltip">
          <mat-icon [class]="action.iconClass || ''">{{ action.icon }}</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Table Area -->
  <div class="entity-table-scroll">
    <table *ngIf="!loading || records.length > 0">
      <thead>
        <tr>
          <th class="checkbox-col" [style.width.px]="columnWidths[0]" [class.frozen-col]="frozenColumnsCount > 0"
            [style.left.px]="frozenColumnsCount > 0 ? 0 : null">
            <mat-checkbox [checked]="allSelected" (change)="toggleAllSelection()"></mat-checkbox>
          </th>
          <th *ngFor="let col of data.columns; let i = index" [style.width.px]="columnWidths[i + 1]"
            (click)="col.sortable && sortBy(col.key)" [class.sortable]="col.sortable"
            [class.frozen-col]="i < frozenColumnsCount"
            [style.left.px]="i < frozenColumnsCount ? getFrozenColumnLeft(i) : null">
            <div class="header-content">
              <span>{{ col.label }}</span>
              <mat-icon *ngIf="col.sortable">{{ getSortIcon(col.key) }}</mat-icon>
            </div>
            <div class="resizer" (mousedown)="onResizeStart($event, i + 1)"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!loading">
          <tr *ngFor="let record of records" (click)="selectRecord(record)"
            [class.selected]="record === selectedRecord">
            <td class="checkbox-col" [style.width.px]="columnWidths[0]" [class.frozen-col]="frozenColumnsCount > 0"
              [style.left.px]="frozenColumnsCount > 0 ? 0 : null">
              <mat-checkbox [checked]="selection.has(record)" (change)="toggleSelection(record)"></mat-checkbox>
            </td>
            <td *ngFor="let col of data.columns; let i = index" [style.width.px]="columnWidths[i + 1]"
              [class.frozen-col]="i < frozenColumnsCount"
              [style.left.px]="i < frozenColumnsCount ? getFrozenColumnLeft(i) : null">
              <div class="entity-cell-content" [class.has-cell-action]="getCellActionConfig(col)">
                <ng-container *ngIf="getCellActionConfig(col) as cellAction; else defaultCellValue">
                  <span *ngIf="shouldShowCellActionValue(cellAction)">{{ formatCellValue(record[col.key], col) }}</span>
                  <button
                  type="button"
                  class="cell-action-button"
                  mat-icon-button
                  [attr.aria-label]="cellAction.tooltip || cellAction.label || 'Open details'"
                  [matTooltip]="cellAction.tooltip || cellAction.label || 'Open details'"
                  (click)="openCellActionDialog($event, record, col, cellAction)">
                    <mat-icon>{{ cellAction.icon || 'edit_note' }}</mat-icon>
                  </button>
                </ng-container>
                <ng-template #defaultCellValue>
                  <span>{{ formatCellValue(record[col.key], col) }}</span>
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div *ngIf="!loading && records.length === 0" class="no-records">
      No records found.
    </div>
  </div>

  <!-- Footer -->
  <div class="entity-card-footer" *ngIf="data?.pagination?.enabled">
    <span>Rows: {{ records.length }}</span> |
    <span>Page Size: {{ data.pagination.pageSize }}</span> |
    <span>Current Page: 1</span>
  </div>

</div>

<ng-template #cellActionDialog>
  <div class="cell-action-dialog-container">
    <div class="cell-action-dialog-header">
      <span class="dialog-title">{{ activeCellDialogTitle }}</span>
      <button type="button" class="dialog-close-btn" (click)="closeCellActionDialog()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="cell-action-dialog-content">
      <div class="cell-action-table-wrap">
        <table class="cell-action-table">
          <thead>
            <tr>
              <th *ngFor="let column of activeCellDialogColumns">{{ column.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of activeCellDialogRows; let rowIndex = index">
              <td *ngFor="let column of activeCellDialogColumns">
                <button
                  *ngIf="column.type === 'button'; else editableCell"
                  type="button"
                  class="cell-action-delete-btn"
                  (click)="removeCellDialogRow(rowIndex)">
                  <mat-icon>{{ column.icon || 'delete' }}</mat-icon>
                  <span>{{ column.buttonLabel || row[column.key] || column.label }}</span>
                </button>
                <ng-template #editableCell>
                  <span *ngIf="column.readonly; else editableInput">
                    {{ row[column.key] }}
                  </span>
                  <ng-template #editableInput>
                    <input
                      class="cell-action-input"
                      [type]="column.type || 'text'"
                      [(ngModel)]="row[column.key]">
                  </ng-template>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="cell-action-footer-meta">
        <span>Rows: {{ activeCellDialogRows.length }}</span>
        <span>|</span>
        <span>Page Size: {{ activeCellDialogPageSize }}</span>
        <span>|</span>
        <span>Current Page: 1</span>
      </div>

      <div class="cell-action-annotations" *ngIf="activeCellDialogConfig?.annotations?.enabled">
        <label>{{ activeCellDialogConfig.annotations.label || 'Annotations' }}</label>
        <textarea [(ngModel)]="activeCellDialogAnnotation"></textarea>
        <div class="cell-action-annotation-row">
          <input [placeholder]="activeCellDialogConfig.annotations.placeholder || 'Add Annotations'">
          <button type="button" class="cell-action-add-note-btn">
            <mat-icon>add</mat-icon>
          </button>
          <span>{{ activeCellDialogConfig.annotations.addButtonLabel || 'Add annotations' }}</span>
        </div>
      </div>
    </div>

    <div class="cell-action-dialog-actions">
      <button type="button" class="btn-cancel" (click)="closeCellActionDialog()">
        {{ activeCellDialogConfig?.cancelButtonLabel || 'Cancel' }}
      </button>
      <button
        *ngIf="activeCellDialogConfig?.hideSaveButton !== true"
        type="button"
        class="btn-ok"
        (click)="saveCellActionDialog()">
        {{ activeCellDialogConfig?.saveButtonLabel || 'Save' }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Settings dialog -->
<ng-template #settingsDialog>
  <div class="settings-dialog-container">
    <div class="settings-dialog-header">
      <span class="dialog-title">Settings</span>
      <button class="dialog-close-btn" (click)="closeSettingsDialog(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="settings-dialog-content">
      <div class="settings-section-card">
        <h4 class="section-card-title">{{ data?.header?.title || 'Entity' }}</h4>

        <div class="settings-form-row">
          <label class="form-label">Records per page</label>
          <input type="number" class="form-input" [(ngModel)]="localPageSize">
        </div>

        <div class="settings-form-row">
          <label class="form-label">Freeze columns</label>
          <input type="number" class="form-input" [(ngModel)]="localFrozenCols">
        </div>

        <div class="settings-form-row">
          <label class="form-label">My defaults</label>
          <div class="select-wrapper">
            <select class="form-select" [(ngModel)]="localDefaults">
              <option value="restore">Restore defaults, Pr...</option>
              <option value="save">Save as default</option>
            </select>
          </div>
        </div>
      </div>

      <div class="settings-section-card">
        <h4 class="section-card-title">All Entity</h4>

        <div class="settings-form-row">
          <label class="form-label">Display format</label>
          <div class="select-wrapper">
            <select class="form-select" [(ngModel)]="localDisplayFormat">
              <option value="code_name">Code&#123;Name&#125;</option>
              <option value="code">Code</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>

        <div class="settings-checkbox-row native-checkbox-row">
          <input type="checkbox" id="showSystemAttribute" [(ngModel)]="localShowSystemAttribute">
          <label for="showSystemAttribute">Show System Attribute</label>
        </div>
      </div>
    </div>

    <div class="settings-dialog-actions">
      <button class="btn-cancel" (click)="closeSettingsDialog(false)">Cancel</button>
      <button class="btn-ok" (click)="closeSettingsDialog(true)">Ok</button>
    </div>
  </div>
</ng-template>

<!-- Settings dialog -->
<ng-template #settingsDialog>
  <div class="settings-dialog-container">
    <div class="settings-dialog-header">
      <span class="dialog-title">Settings</span>
      <button class="dialog-close-btn" (click)="closeSettingsDialog(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="settings-dialog-content">
      <div class="settings-section-card">
        <h4 class="section-card-title">{{ data?.header?.title || 'Entity' }}</h4>

        <div class="settings-form-row">
          <label class="form-label">Records per page</label>
          <input type="number" class="form-input" [(ngModel)]="localPageSize">
        </div>

        <div class="settings-form-row">
          <label class="form-label">Freeze columns</label>
          <input type="number" class="form-input" [(ngModel)]="localFrozenCols">
        </div>

        <div class="settings-form-row">
          <label class="form-label">My defaults</label>
          <div class="select-wrapper">
            <select class="form-select" [(ngModel)]="localDefaults">
              <option value="restore">Restore defaults, Pr...</option>
              <option value="save">Save as default</option>
            </select>
          </div>
        </div>
      </div>

      <div class="settings-section-card">
        <h4 class="section-card-title">All Entity</h4>

        <div class="settings-form-row">
          <label class="form-label">Display format</label>
          <div class="select-wrapper">
            <select class="form-select" [(ngModel)]="localDisplayFormat">
              <option value="code_name">Code&#123;Name&#125;</option>
              <option value="code">Code</option>
              <option value="name">Name</option>
            </select>
          </div>
        </div>

        <div class="settings-checkbox-row native-checkbox-row">
          <input type="checkbox" id="showSystemAttribute" [(ngModel)]="localShowSystemAttribute">
          <label for="showSystemAttribute">Show System Attribute</label>
        </div>
      </div>
    </div>

    <div class="settings-dialog-actions">
      <button class="btn-cancel" (click)="closeSettingsDialog(false)">Cancel</button>
      <button class="btn-ok" (click)="closeSettingsDialog(true)">Ok</button>
    </div>
  </div>
</ng-template>
